import { QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { ConfirmProvider } from '@/components/ui/Confirm';
import { ToastProvider } from '@/components/ui/Toast';
import { AuthProvider } from '@/lib/auth';
import { createQueryClient } from '@/lib/api';
import { LiveRegionProvider } from '@/lib/hooks';
import { I18nProvider } from '@/lib/i18n';
import { LibraryProvider } from '@/lib/library';
import { ThemeProvider } from '@/lib/theme';
import { ErrorBoundary } from './system-pages';

/** Provider stack, outermost first. Everything here is app-wide state; per-feature state stays in features. */
export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <I18nProvider>
          <QueryClientProvider client={queryClient}>
            <LiveRegionProvider>
              <ToastProvider>
                <ConfirmProvider>
                  <AuthProvider>
                    <LibraryProvider>{children}</LibraryProvider>
                  </AuthProvider>
                </ConfirmProvider>
              </ToastProvider>
            </LiveRegionProvider>
          </QueryClientProvider>
        </I18nProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
